import { isPardusBrowser } from '@/components/check-user-agent';
import { ActionTooltip } from '../action-tooltip';
import { DownloadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppDownload } from '@/hooks/use-app-download.ts';
import { getOperatingSystem } from '@/lib/utils.ts';

export const GetApp = () => {
  const { t } = useTranslation();
  const { downloadUrl, isReady } = useAppDownload();
  const os = getOperatingSystem();

  if (isPardusBrowser() || !isReady || !downloadUrl) {
    return null;
  }
  // if (os == 'mac') return null;

  return (
    <ActionTooltip side="right" align="center" label={t('NavigationGetApp.tooltip')}>
      <button
        onClick={() => window.open(downloadUrl, '_blank')}
        className="group flex items-center"
      >
        <div className="mx-3 flex size-[48px] items-center justify-center overflow-hidden rounded-[24px] bg-background transition-all group-hover:rounded-[16px] group-hover:bg-black dark:bg-neutral-700">
          <DownloadIcon
            size={25}
            className="text-black transition group-hover:text-white dark:text-white"
          />
        </div>
      </button>
    </ActionTooltip>
  );
};
